import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Menu,
  Autocomplete,
} from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarQuickFilter,
  GridToolbar,
} from "@mui/x-data-grid";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import { Form, Alert } from "react-bootstrap";
import { apiUrl } from "../services/api";
import {
  Delete,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Print,
} from "@mui/icons-material";
import Header from "../components/Header";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

const Contrat = () => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [contratToDelete, setContratToDelete] = useState(null);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [contrats, setContrats] = useState([]);
  const [formData, setFormData] = useState({
    date_contrat: "",
    id_conducteur: "",
    id_conducteur2: "",
    id_voiture: "",
    date_depart: "",
    heure_depart: "",
    date_retour: "",
    heure_retour: "",
    kilometrage_depart: "",
    kilometrage_retour: "",
    lieu_depart: "",
    lieu_retour: "",
    prix_location: "",
    caution: "",
    motif: "",
  });
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const navigate = useNavigate();
  const [voitures, setVoitures] = useState([]);
  const [voituresFiltred, setVoituresFiltred] = useState([]);
  const [conducteurs, setConducteurs] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedContratId, setSelectedContratId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const open = Boolean(anchorEl);

  const handlePrintClick = (event, params) => {
    setAnchorEl(event.currentTarget);
    setSelectedContratId(params.row.id_contrat);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePrintOption = (path) => {
    navigate(`${path}/${selectedContratId}`);
    handleClose();
  };

  const fetchVoitures = async () => {
    try {
      const response = await axios.get(`${apiUrl}/voiture`);
      setVoitures(response.data);
    } catch (err) {
      console.error("Error fetching voitures:", err);
    }
  };

  const fetchConducteurs = async () => {
    try {
      const response = await axios.get(`${apiUrl}/conducteur`);
      setConducteurs(response.data);
    } catch (err) {
      console.error("Error fetching Conducteurs:", err);
    }
  };

  const fetchContrats = async () => {
    try {
      const response = await axios.get(`${apiUrl}/contrat`);
      setContrats(response.data);
    } catch (err) {
      console.error("Error fetching contrats:", err);
    }
  };

  const fetchFilteredVoitures = async () => {
    try {
      const response = await axios.get(`${apiUrl}/voiture/disponible/voiture`);
      setVoituresFiltred(response.data);
    } catch (err) {
      console.error("Error fetching and filtering voitures:", err);
    }
  };

  useEffect(() => {
    fetchConducteurs();
    fetchContrats();
    fetchVoitures();
    fetchFilteredVoitures();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAddContrat = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (editing) {
        response = await axios.put(`${apiUrl}/contrat/${editId}`, formData);
      } else {
        response = await axios.post(`${apiUrl}/contrat`, formData);
      }
      console.log("Server response:", response.data);
      await fetchContrats();
      setEditing(false);
      setEditId(null);
      setFormData({
        date_contrat: "",
        id_conducteur: "",
        id_conducteur2: "",
        id_voiture: "",
        date_depart: "",
        heure_depart: "",
        date_retour: "",
        heure_retour: "",
        kilometrage_depart: "",
        kilometrage_retour: "",
        lieu_depart: "",
        lieu_retour: "",
        prix_location: "",
        caution: "",
        motif: "",
      });
    } catch (err) {
      console.error("Error adding/updating contrat:", err);
      setError(err.response?.data?.message || "Failed to add/update contrat");
    }
    setShowForm(false);
    fetchFilteredVoitures();
  };

  const handleEditContrat = (contrat) => {
    setEditing(true);
    setEditId(contrat.id_contrat);
    setFormData({
      date_contrat: contrat.date_contrat,
      date_depart: contrat.date_depart,
      heure_depart: contrat.heure_depart,
      date_retour: contrat.date_retour,
      heure_retour: contrat.heure_retour,
      kilometrage_depart: contrat.kilometrage_depart,
      kilometrage_retour: contrat.kilometrage_retour,
      lieu_depart: contrat.lieu_depart,
      lieu_retour: contrat.lieu_retour,
      id_conducteur: contrat.id_conducteur,
      id_conducteur2: contrat.id_conducteur2,
      id_voiture: contrat.id_voiture,
      prix_location: contrat.prix_location,
      caution: contrat.caution,
      motif: contrat.motif,
    });
    setShowForm(true);
    fetchFilteredVoitures();
  };

  const handleOpenConfirmDialog = (id) => {
    console.log("Delete ID:", id); // Check if correct ID is being set
    setContratToDelete(id);
    setConfirmOpen(true);
  };

  const handleCloseConfirmDialog = () => {
    setConfirmOpen(false);
    setContratToDelete(null); // Reset the ID
  };
  const handleDeleteContrat = async () => {
    if (!contratToDelete) return;

    try {
      const response = await axios.delete(
        `${apiUrl}/contrat/${contratToDelete}`
      );

      if (response.data.canDelete) {
        console.log("Deleted contrat with ID:", contratToDelete);
        fetchContrats(); // Refresh the list
        setMessage("Contrat deleted successfully");
        setMessageType("success");
      } else {
        setMessage(response.data.message);
        setMessageType("warning"); // Use a different type for this case
      }

      setConfirmOpen(false); // Close the confirmation dialog
    } catch (err) {
      console.error("Error deleting contrat:", err);

      // Get the error message from the server response
      const errorMessage =
        err.response?.data?.message || "Failed to delete contrat";

      setMessage(errorMessage);
      setMessageType("error");
      setConfirmOpen(false); // Close the confirmation dialog
      fetchFilteredVoitures();
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return format(date, "yyyy-MM-dd");
  };

  const columns = [
    {
      field: "id_contrat",
      headerName: "ID",
      width: 100,
      cellClassName: "name-column--cell2",
    },
    {
      field: "date_contrat",
      headerName: "Date du contrat",
      width: 120,
      cellClassName: "name-column--cell",
    },
    {
      field: "date_depart",
      headerName: "Date de départ",
      width: 120,
      cellClassName: "name-column--cell2",
    },
    {
      field: "heure_depart",
      headerName: "Heure de départ",
      width: 120,
      cellClassName: "name-column--cell",
    },
    {
      field: "date_retour",
      headerName: "Date de retour",
      width: 120,
      cellClassName: "name-column--cell2",
    },
    {
      field: "heure_retour",
      headerName: "Heure de retour",
      width: 120,
      cellClassName: "name-column--cell",
    },
    {
      field: "kilometrage_depart",
      headerName: "Kilométrage de départ",
      width: 150,
      cellClassName: "name-column--cell2",
    },
    {
      field: "kilometrage_retour",
      headerName: "Kilométrage de retour",
      width: 150,
      cellClassName: "name-column--cell",
    },
    {
      field: "lieu_depart",
      headerName: "Lieu de départ",
      width: 150,
      cellClassName: "name-column--cell2",
    },
    {
      field: "lieu_retour",
      headerName: "Lieu de retour",
      width: 150,
      cellClassName: "name-column--cell",
    },
    {
      field: "n_conducteur",
      headerName: "Conducteur",
      width: 100,
      cellClassName: "name-column--cell2",
    },
    {
      field: "n_conducteur2",
      headerName: "2eme Conducteur",
      width: 150,
      cellClassName: "name-column--cell2",
      renderCell: (params) => {
        return params.value || "-";
      },
    },
    {
      field: "id_voiture",
      headerName: "Voiture",
      width: 100,
      cellClassName: "name-column--cell",
      renderCell: (params) => {
        return voitures
          .filter((voiture) => voiture.id_voiture === params.value)
          .map((voiture) => voiture.marque + " " + voiture.matricule);
      },
    },
    {
      field: "prix_location",
      headerName: "Prix de location",
      width: 120,
      cellClassName: "name-column--cell2",
    },
    {
      field: "caution",
      headerName: "Caution",
      width: 100,
      cellClassName: "name-column--cell",
    },
    {
      field: "motif",
      headerName: "Motif",
      width: 150,
      cellClassName: "name-column--cell2",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      cellClassName: "actions",
      renderCell: (params) => (
        <>
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit"
            onClick={() => handleEditContrat(params.row)}
            color="inherit"
          />
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={() => handleOpenConfirmDialog(params.row.id_contrat)}
            color="inherit"
          />
          <GridActionsCellItem
            icon={<Print />}
            label="Print"
            onClick={(event) => handlePrintClick(event, params)}
            color="inherit"
          />
        </>
      ),
    },
  ];

  return (
    <div>
      <Header title="Contrats" subtitle="Gestion des contrats de location." />
      {error && <Alert variant="danger">{error}</Alert>}
      {message && (
        <div
          className={`message ${messageType}`}
          style={{
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "4px",
            backgroundColor: messageType === "success" ? "#d4edda" : "#f8d7da",
            color: messageType === "success" ? "#155724" : "#721c24",
            border: `1px solid ${
              messageType === "success" ? "#c3e6cb" : "#f5c6cb"
            }`,
          }}
        >
          {message}
        </div>
      )}
      <Dialog
        open={confirmOpen}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="confirm-dialog-title"
      >
        <DialogTitle id="confirm-dialog-title">
          Confirmer la suppression
        </DialogTitle>
        <DialogContent>
          Êtes-vous sûr de vouloir supprimer ce contrat ?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="primary">
            Annuler
          </Button>
          <Button onClick={handleDeleteContrat} color="secondary" autoFocus>
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
      <Button
        onClick={() => setShowForm(!showForm)}
        variant="contained"
        sx={{
          color: colors.primary[500],
          backgroundColor: colors.greenAccent[500],
          ":hover": {
            color: colors.primary[500],
            backgroundColor: colors.greenAccent[300],
          },
          marginBottom: "20px",
        }}
      >
        {showForm ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </Button>
      {showForm && (
        <Form onSubmit={handleAddContrat}>
          <Box
            display="grid"
            gap="20px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          >
            <TextField
              label="Date du contrat"
              name="date_contrat"
              type="date"
              value={formData.date_contrat}
              onChange={handleInputChange}
              required
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            {/* <FormControl
              fullWidth
              sx={{ gridColumn: "span 1" }}
              color="secondary"
              margin="normal"
              required
            > */}
            <Autocomplete
              fullWidth
              id="id_conducteur"
              options={conducteurs}
              getOptionLabel={(option) => `${option.nom} - ${option.prenom}`}
              value={
                conducteurs.find(
                  (c) => c.id_conducteur === formData.id_conducteur
                ) || null
              }
              onChange={(event, newValue) => {
                handleInputChange({
                  target: {
                    name: "id_conducteur",
                    value: newValue ? newValue.id_conducteur : null,
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Conducteur"
                  required
                  margin="normal"
                  color="secondary"
                />
              )}
            />
            {/* </FormControl> */}
            <Autocomplete
              fullWidth
              id="id_conducteur2"
              options={conducteurs}
              getOptionLabel={(option) => `${option.nom} - ${option.prenom}`}
              value={
                conducteurs.find(
                  (c) => c.id_conducteur === formData.id_conducteur2
                ) || null
              }
              onChange={(event, newValue) => {
                handleInputChange({
                  target: {
                    name: "id_conducteur2",
                    value: newValue ? newValue.id_conducteur : null,
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="2eme Conducteur"
                  margin="normal"
                  color="secondary"
                />
              )}
            />
            <FormControl
              fullWidth
              sx={{ gridColumn: "span 1" }}
              color="secondary"
              margin="normal"
              required
            >
              <InputLabel id="bptnum-label">Voiture</InputLabel>
              <Select
                labelId="bptnum-label"
                id="id_voiture"
                value={formData.id_voiture}
                label="Voiture"
                onChange={handleInputChange}
                name="id_voiture"
              >
                <MenuItem value={null}>{" - "}</MenuItem>
                {editing
                  ? voitures.map((option) => (
                      <MenuItem
                        key={option.id_voiture}
                        value={option.id_voiture}
                      >
                        {option.marque + " - " + option.matricule}
                      </MenuItem>
                    ))
                  : voituresFiltred.map((option) => (
                      <MenuItem
                        key={option.id_voiture}
                        value={option.id_voiture}
                      >
                        {option.marque + " - " + option.matricule}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
            <TextField
              label="Date de départ"
              name="date_depart"
              type="date"
              value={formData.date_depart}
              onChange={handleInputChange}
              required
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Heure de départ"
              name="heure_depart"
              type="time"
              value={formData.heure_depart}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Date de retour"
              name="date_retour"
              type="date"
              value={formData.date_retour}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Heure de retour"
              name="heure_retour"
              type="time"
              value={formData.heure_retour}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Kilométrage de départ"
              name="kilometrage_depart"
              type="number"
              value={formData.kilometrage_depart}
              onChange={handleInputChange}
              required
              fullWidth
              margin="normal"
            />
            <TextField
              label="Kilométrage de retour"
              name="kilometrage_retour"
              type="number"
              value={formData.kilometrage_retour}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Lieu de départ"
              name="lieu_depart"
              value={formData.lieu_depart}
              onChange={handleInputChange}
              required
              fullWidth
              margin="normal"
            />
            <TextField
              label="Lieu de retour"
              name="lieu_retour"
              value={formData.lieu_retour}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Prix de location"
              name="prix_location"
              type="number"
              value={formData.prix_location}
              onChange={handleInputChange}
              required
              fullWidth
              margin="normal"
            />
            <TextField
              label="Caution"
              name="caution"
              type="number"
              value={formData.caution}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Motif"
              name="motif"
              value={formData.motif}
              onChange={handleInputChange}
              fullWidth
              color="secondary"
              margin="normal"
              multiline
              rows={2}
            />
          </Box>
          <Button
            variant="contained"
            type="submit"
            sx={{
              color: colors.primary[500],
              backgroundColor: colors.greenAccent[500],
              ":hover": {
                color: colors.primary[500],
                backgroundColor: colors.greenAccent[300],
              },
            }}
          >
            {editing ? "Modifier Contrat" : "Ajouter Contrat"}
          </Button>
        </Form>
      )}

      <Box
        m="40px 0 0 0"
        maxHeight="75"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .name-column--cell2": {
            color: colors.redAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
          "& .MuiDataGrid-root .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-main": {
            overflow: "auto",
          },
        }}
      >
        <DataGrid
          rows={
            contrats.length > 0
              ? contrats.map((contrat) => ({
                  id_contrat: contrat.id_contrat,
                  id_conducteur: contrat.id_conducteur,
                  id_conducteur2: contrat.id_conducteur2,
                  id_voiture: contrat.id_voiture,
                  date_contrat: formatDate(contrat.date_contrat),
                  n_conducteur: conducteurs
                    .filter(
                      (conducteur) =>
                        conducteur.id_conducteur === contrat.id_conducteur
                    )
                    .map(
                      (conducteur) => conducteur.nom + " " + conducteur.prenom
                    ),
                  n_conducteur2: contrat.id_conducteur2
                    ? conducteurs
                        .filter(
                          (conducteur) =>
                            conducteur.id_conducteur === contrat.id_conducteur2
                        )
                        .map(
                          (conducteur) =>
                            conducteur.nom + " " + conducteur.prenom
                        )
                    : null,
                  // n_voiture: voitures
                  //   .filter(
                  //     (voiture) => voiture.id_voiture === contrat.id_voiture
                  //   )
                  //   .map((voiture) => voiture.marque + " " + voiture.matricule),
                  date_depart: formatDate(contrat.date_depart),
                  heure_depart: contrat.heure_depart,
                  date_retour: formatDate(contrat.date_retour),
                  heure_retour: contrat.heure_retour,
                  kilometrage_depart: contrat.kilometrage_depart,
                  kilometrage_retour: contrat.kilometrage_retour,
                  lieu_depart: contrat.lieu_depart,
                  lieu_retour: contrat.lieu_retour,
                  prix_location: contrat.prix_location,
                  caution: contrat.caution,
                  motif: contrat.motif,
                }))
              : []
          }
          columns={columns}
          getRowId={(row) => row.id_contrat}
          components={{ Toolbar: CustomToolbar }}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableExtendRowFullWidth={true}
          autoHeight={true}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
        />
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => handlePrintOption("/print-contrat")}>
          Contrat
        </MenuItem>
        <MenuItem onClick={() => handlePrintOption("/print-engagement")}>
          Engagement
        </MenuItem>
        <MenuItem onClick={() => handlePrintOption("/print-dplvsc")}>
          DPAL
        </MenuItem>
        <MenuItem onClick={() => handlePrintOption("/print-dai")}>DAI</MenuItem>
      </Menu>
    </div>
  );
};

const csvOptions = {
  fileName: "Contrats",
  delimiter: ";",
  utf8WithBom: true,
};
const printOptions = {
  hideFooter: true,
  hideToolbar: true,
  includeCheckboxes: true,
};

function CustomExportButtons(props) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
      <GridPrintExportMenuItem options={printOptions} />
    </GridToolbarExportContainer>
  );
}

function CustomToolbar(props) {
  return (
    <GridToolbarContainer {...props}>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <CustomExportButtons />
      <Box sx={{ marginLeft: "auto", pl: 0, pr: 0, pb: 0, pt: 0 }}>
        <GridToolbarQuickFilter />
      </Box>
    </GridToolbarContainer>
  );
}

export default Contrat;
